
import { nanoid } from 'nanoid';


export const codeInfomation = [
     {
          id: nanoid(),
          name: 'React Dark and Light Theme Toggle button',
          language: 'React js & tsx',
          imageUrl: 'https://create-react-app.dev/img/logo.svg',
          description: 'Discover how to effortlessly switch between light and dark modes in React with our theme toggle feature. Experience a seamless and adaptive user interface that suits your style.',
          codeTsx: `import { DarkMode, LightMode } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'


const ThemeMode = () => {
     const defaultTheme = localStorage.getItem('theme') || 'light';

     document.documentElement.style.setProperty('color-scheme', defaultTheme);

     const [theme, setTheme] = useState(defaultTheme === 'dark');

     useEffect(() => {
          const newTheme = theme ? 'dark' : 'light';
          document.documentElement.style.setProperty('color-scheme', newTheme);
          localStorage.setItem('theme', newTheme);
     }, [theme]);

     const toggleDarkMode = () => {
          setTheme(prevTheme => !prevTheme);
     };

     return (
          <>
               <button onClick={toggleDarkMode} className='theme-btn'>
                    <span> {theme ? <DarkMode /> : <LightMode />} </span>
               </button>
          </>
     )
}

export default ThemeMode`,
          codescss: `
:root {
    --body: light-dark(#fff, #000);
    --txt-white: light-dark(#fff, #000);
    --txt-black: light-dark(#000, #fff);
}
body {
    background-color: var(--body);
    color: var(--txt-black);
}`     },
{
     id: nanoid(),
     name: 'cursor-based parallax effect in React',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'A section or area where the parallax effect is applied to cards or elements, making them move as the user moves their cursor over the section',
     codeTsx: `import React, { useState } from 'react'
const CursorBased = () => {

    // thedc.tech => 

     const [offsetX, setOffsetX] = useState(0);
     const [offsetY, setOffsetY] = useState(0);

     // Function to handle mouse movement
     const handleMouseMove = (e: any) => {
          const { clientX, clientY, currentTarget } = e;
          const { offsetWidth, offsetHeight } = currentTarget;

          // Calculate cursor position relative to the element
          const xPos = (clientX / offsetWidth) - 0.5; 
          const yPos = (clientY / offsetHeight) - 0.5; 

          // Update offset state based on cursor position
          setOffsetX(xPos * 30);
          setOffsetY(yPos * 30);
     };



return (

        <>
            <div className="parent-section" onMouseMove={handleMouseMove}>

                <div className="animation-move" style={{ transform: \`translate(\${offsetX}px, \${offsetY}px)\` }}> </div>

            </div>

        </>
    )
}

export default CursorBased

     `,
     codescss: `.animation-move{
    background-image: url(chhose.item);
}`
},
{
     id: nanoid(),
     name: 'following dot effect a cursor circle using React',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'The dot\'s position is updated to follow the cursor with a slight delay to create the trailing effect. A larger circle moves with the cursor to act as the outer boundary.',
     codeTsx: `
// Import necessary hooks from React
const [dotPosition, setDotPosition] = useState({ x: 0, y: 0 });
const [circlePosition, setCirclePosition] = useState({ x: 0, y: 0 });

// Function to handleMouseMove movement
useEffect(() => {
const handleMouseMove = (event: MouseEvent) => {
 setCirclePosition({ x: event.clientX, y: event.clientY });

 // Simulate the dot lagging behind the cursor
 setTimeout(() => {
   setDotPosition({ x: event.clientX, y: event.clientY });
 }, 100); // Adjust delay to increase or decrease the lag effect
};

window.addEventListener("mousemove", handleMouseMove);

return () => {
 window.removeEventListener("mousemove", handleMouseMove);
};
}, []);

// jsx , tsx, js for rendering

 <div
   style={{
     position: "fixed",
     left: \`\${circlePosition.x - 25}px\`,
     top: \`\${circlePosition.y - 25}px\`,
     width: "50px",
     height: "50px",
     borderRadius: "50%",
     backgroundColor: "#1e1e20",
     pointerEvents: "none",
     transform: isInFooter ? 'scale(1.5)' : 'none',
     zIndex: '99999',
     transition: 'all 0.1s linear',
   }}
 />
 <div
   style={{
     position: "fixed",
     left: \`\${dotPosition.x - 5}px\`,
     top: \`\${dotPosition.y - 5}px\`,
     width:'15px',
     height:'15px',
     borderRadius: "50%",
     backgroundColor: 'var(--primary-color)',
     pointerEvents: "none",
     zIndex: '99999',
     transition: 'all 0.1s linear',
     display: isInFooter ? "none": 'block'
   }}
 />

`},
{
     id: nanoid(),
     name: 'Header Link Active By Path True ',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'This code snippet demonstrates how to dynamically add an "active" class to a link based on the current URL path in a React application using React Router. The Link component checks if the current path matches the specified route (/URL). If they match, it assigns the activeLink class along with the default Link-class, providing a visual indication that the link corresponds to the current page.',
     codeTsx: `
import React from 'react'
import { Link, useLocation } from 'react-router-dom'


const AdddClassURL = () => {

    const location = useLocation();

    return (
        <>

            <Link to="/URL" className={location.pathname === '/URL' ? "Link-class activeLink" : ' Link-class'}> Link Name </Link>

        </>
    )
}

export default AdddClassURL

`},
{
     id: nanoid(),
     name: 'When the page is active, add a class to the body ',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'This code snippet uses the useEffect hook to add a class (add-class-body) to the <body> element when the current URL path matches a specified path (/page_url). If the URL path changes and no longer matches, the class is removed. This ensures the class is only active on a specific page.',
     codeTsx: `
import React, { useEffect } from 'react'


const AdddClass = () => {


    const path = "/page_url";

    useEffect(() => {
        if (location.pathname === path) {
            document.body.classList.add('add-class-body');
        } else {
            document.body.classList.remove('add-class-body');
        }
    }, [location.pathname]);



    return (
          //  add-class-body style Your Accoding
        <h3> ADD Class in Body</h3>
    )
}

export default AdddClass`},
{
     id: nanoid(),
     name: 'When the button is clicked, add a class to the body ',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'This code snippet uses the useEffect hook to add a class (add-class-body) to the <body> element when the current URL path matches a specified path (/page_url). If the URL path changes and no longer matches, the class is removed. This ensures the class is only active on a specific page.',
     codeTsx: `
import React, { useEffect, useState } from 'react'


const AdddClass = () => {


    // 1. simple button click add class
    const AddClass = () => {
        document.body.classList.toggle("add-class-body");
        // remove class create a function classList attribute change (.remove)
    };

    // 2 Button click if isActive True than, add a class to the body
    const [isActive, setIsActive] = useState(false);

    const AddClassWithState = () => {
        setIsActive(!isActive);


        if (!isActive) {
            document.body.classList.add('add-class-body');
        } else {
            document.body.classList.remove('add-class-body');
        }
    };
  
    
    return (
        <>

            <button onClick={AddClass}> add class Onclick</button>
            <button onClick={AddClassWithState}> add class With State</button>

            <div className={\`section \${isActive ? 'add-class-sec' : ''}\`}>
            State true false 
            </div>
        </>
    )
}

export default AdddClass`},
{
     id: nanoid(),
     name: 'Handle Click Event Based on Screen Size in React',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'In this code, we create a handleClick function that triggers an action only when the screen size is 768px or less. The function toggles a CSS class on the body element depending on whether a specific condition is active. This can be useful when we want to apply different behaviors or styles for mobile screens.',
     description_1: 'The key idea is to use the window.matchMedia() method, which allows us to detect the current screen size and trigger the click event based on that condition.',
     codeTsx: `
import React, { useState } from 'react'


const AdddClass = () => {

    // handleClick function that works for mobile screens (max-width: 768px) "example width"

    const [isActive, setIsActive] = useState(false);

    const handleClick = () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        if (isMobile) {
            setIsActive(!isActive);

            if (!isActive) {
                document.body.classList.add('ExampleClass');

            } else {
                document.body.classList.remove('ExampleClass');
            }
        }
    };


    return (
        <>
            <button onClick={handleClick}> Handle Click Event Based on Screen Size in React</button>

        </>
    )
}

export default AdddClass

`},
{
     id: nanoid(),
     name: 'Simple Accordion or Advanced Accordion',
     language: 'React js & tsx',
     imageUrl: 'https://create-react-app.dev/img/logo.svg',
     description: 'Got questions? We’ve got answers! Browse through our FAQ section to clear your doubts quickly.',
     codeTsx: `import React from 'react'
import { Accordion } from 'react-bootstrap'

const AccordionIN = () => {

    // Demo FAQ data array
    const faqData = [
        {
            question: 'What is React?',
            answers: [
                'React is a JavaScript library for building user interfaces.',
                'It is maintained by Facebook and a community of developers.'
            ]
        },
        {
            question: 'How do I install React?',
            answers: ['You can install React using npm or yarn: npm install react react-dom.']
        },
        {
            question: 'What is the difference between state and props?',
            answers: [
                'State is a local data storage that is mutable.',
                'Props are immutable and passed down from parent components.'
            ]
        }
    ];


    return (

        <div className='faq-sec'>
            {/* Advanced Accordion (Pro Design - .advance-accordion Applied)  */}
            <Accordion defaultActiveKey="0">
                {faqData.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>
                            <p>{faq.question}</p>
                            <p className='__icon'>
                                <svg viewBox="0 0 16 16" fill="none" stroke="auto" >
                                    <path d="M2 5L8 11L14 5" />
                                </svg>
                            </p>
                        </Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                {faq.answers.map((answer, idx) => (
                                    <li key={idx}> {answer}</li>
                                ))}
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>
    )
}

export default AccordionIN
`,
codescss: `.faq-sec {
    // variables
    --active-bg: orange;
    --dc-ac-fz: 14px;
    --dc-ac-bs: 1px solid;
    --dc-ac-br: 20px;

    --dc-ac-bg: light-dark(#fff, hsla(0, 0%, 100%, .1));
    --dc-ac-c: light-dark(#000, #fff);
    --dc-ac-bc: light-dark(#dcdcdc, #383636);
    --dc-outArea: light-dark(#fff, #000);

    color-scheme: dark;
    background-color: var(--dc-outArea);
    padding: 20px;

    @media (max-width:576px) {
         padding: 20px 16px;
    }


    .accordion {
         color: var(--dc-ac-c);

         .accordion-item {
              background-color: var(--dc-ac-bg);
              border: var(--dc-ac-bs) var(--dc-ac-bc);
              color: var(--dc-ac-c);
              border-radius: var(--dc-ac-br);
              overflow: hidden;
              margin-bottom: 20px;
              font-size: var(--dc-ac-fz);

              &:last-child {
                   margin-bottom: 0;
              }

              .accordion-header {

                   .accordion-button {
                        background-color: transparent;
                        border: 0;
                        color: var(--dc-ac-c);
                        box-shadow: unset;
                        font-size: var(--dc-ac-fz);
                        justify-content: space-between;
                        width: 100%;
                        padding: 1rem;

                        p {
                             margin-bottom: 0;
                        }

                        svg {
                             stroke: var(--dc-ac-c);
                             width: 20px;
                             transform: rotate(0deg);
                             transition: all 0.3s linear;
                        }

                        &::after {
                             display: none;
                        }
                   }

                   .accordion-button[aria-expanded="false"] {
                        svg {
                             transform: rotate(180deg);
                        }
                   }
              }

              .accordion-body {
                   border-top: var(--dc-ac-bs) var(--dc-ac-bc);
                   padding: 14px 15px 10px;

                   ul {
                        list-style-type: circle;

                        @media (max-width:576px) {
                             padding-left: 10px;
                        }

                        li {
                             margin-bottom: 5px;
                             font-size: var(--dc-ac-fz);
                        }
                   }

              }
         }

         // advance-accordion add class in accordion 

         &.advance-accordion {
              .accordion-item {
                   background-color: transparent;
                   border: 0;
                   border-radius: 0;
                   border-bottom: var(--dc-ac-bs) var(--dc-ac-bc);


                   .accordion-button {

                        .__icon {
                             background-color: var(--active-bg);
                             padding: 10px;
                             border-radius: var(--dc-ac-br);
                        }
                   }
              }

              .accordion-body {
                   border: 0;
              }
         }
    }
}`},



];